import { ACCEPT_ORDERS_FAILURE, ACCEPT_ORDERS_REQUEST, CANCELED_ORDER_FAILURE, CANCELED_ORDER_REQUEST, CHANGE_ORDER_DELIVERY_DATE_FAILURE, CHANGE_ORDER_DELIVERY_DATE_REQUEST, DELETE_ORDER_FAILURE, DELETE_ORDER_REQUEST, DELIVERED_ORDER_FAILURE, DELIVERED_ORDER_REQUEST, GET_NEW_ORDERS_FAILURE, GET_NEW_ORDERS_REQUEST, GET_NEW_ORDERS_SUCCESS, GET_ORDER_STATS_FAILURE, GET_ORDER_STATS_REQUEST, GET_ORDER_STATS_SUCCESS, GET_ORDERS_FAILURE, GET_ORDERS_REQUEST, GET_ORDERS_SUCCESS, PLACED_ORDER_FAILURE, PLACED_ORDER_REQUEST, SHIP_ORDER_FAILURE, SHIP_ORDER_REQUEST, GET_INCOME_FAILURE, GET_INCOME_REQUEST, GET_INCOME_SUCCESS, RETURN_PICKED_ORDER_REQUEST, RETURN_COMPLETED_ORDER_REQUEST, RETURN_PICKED_ORDER_FAILURE, RETURN_COMPLETED_ORDER_FAILURE, } from "./ActionType";


const initialState = {
    loading: false,
    orders: [],
    newOrders: [],
    orderStats: null,
    income: null,
    error: "",
}

const employeeOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORDERS_REQUEST:
            return { ...state, loading: true };

        case GET_ORDERS_SUCCESS:
            return { ...state, loading: false, orders: action.payload, error: "" };

        case GET_ORDERS_FAILURE:
            return { ...state, loading: false, orders: [], error: action.payload };

        case GET_ORDER_STATS_REQUEST:
            return { ...state, loading: true };

        case GET_ORDER_STATS_SUCCESS:
            return { ...state, loading: false, orderStats: action.payload, error: "" };

        case GET_ORDER_STATS_FAILURE:
            return { ...state, loading: false, orderStats: null, error: action.payload };

        case GET_INCOME_REQUEST:
            return { ...state, loading: true };

        case GET_INCOME_SUCCESS:
            return { ...state, loading: false, income: action.payload, error: "" };

        case GET_INCOME_FAILURE:
            return { ...state, loading: false, income: null, error: action.payload };

        case GET_NEW_ORDERS_REQUEST:
            return { ...state, loading: true };

        case GET_NEW_ORDERS_SUCCESS:
            return { ...state, loading: false, newOrders: action.payload, error: "" };

        case GET_NEW_ORDERS_FAILURE:
            return { ...state, loading: false, newOrders: [], error: action.payload };

        case ACCEPT_ORDERS_REQUEST:
            return { ...state, loading: true };

        case ACCEPT_ORDERS_FAILURE:
            return { ...state, loading: false, newOrders: [], error: action.payload };

        case PLACED_ORDER_REQUEST:
        case DELIVERED_ORDER_REQUEST:
        case CANCELED_ORDER_REQUEST:
        case SHIP_ORDER_REQUEST:
        case CHANGE_ORDER_DELIVERY_DATE_REQUEST:
        case RETURN_PICKED_ORDER_REQUEST:
        case RETURN_COMPLETED_ORDER_REQUEST:
            return { ...state, loading: true, error: "" };

        case PLACED_ORDER_FAILURE:
        case DELIVERED_ORDER_FAILURE:
        case CANCELED_ORDER_FAILURE:
        case SHIP_ORDER_FAILURE:
        case CHANGE_ORDER_DELIVERY_DATE_FAILURE:
        case RETURN_PICKED_ORDER_FAILURE:
        case RETURN_COMPLETED_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case DELETE_ORDER_REQUEST:
            return { ...state, loading: true, error: "" };

        case DELETE_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
}
export default employeeOrderReducer